import React, { type FC, type PropsWithChildren, useState, useEffect } from 'react';
import { DeviceTypeContext } from '../contexts/DeviceType';
import { type DeviceType } from '../types/DeviceType';
import { getDeviceType, getDeviceTypeObserver } from './deviceType';

export const DeviceTypeProvider: FC<
  PropsWithChildren<{
    deviceTypeFromConsumer: DeviceType;
    onDeviceTypeChange?(): void;
  }>
> = (props) => {
  const { deviceTypeFromConsumer } = props;
  const [deviceType, setDeviceType] = useState(deviceTypeFromConsumer || getDeviceType());

  useEffect(() => {
    // need to manually track the device type change only if the Consumer App doesn't pass "deviceType" prop
    if (!deviceTypeFromConsumer) {
      const updateDeviceType = () => {
        props.onDeviceTypeChange?.();
        setDeviceType(getDeviceType());
      };

      const deviceTypeObserver = getDeviceTypeObserver();

      // add/removeEventListener can't be used due to missing support in older browsers
      deviceTypeObserver.addListener(updateDeviceType);

      return () => {
        deviceTypeObserver.removeListener(updateDeviceType);
      };
    }
  }, []);

  return <DeviceTypeContext.Provider value={deviceType}>{props.children}</DeviceTypeContext.Provider>;
};
